import { usePlanAddonsDescriptions } from 'src/react_query'
import { PlansDescription } from 'src/marketing/plans/types'

export const usePlanAddons = () => {
  const { data: planAddonsDescriptions } = usePlanAddonsDescriptions()
  const addonOptions = (planAddonsDescriptions ?? [])
    .map(PlansDescription.fromPlansDescriptionFragment)
    .sort(
      (a, b) =>
        (a.description?.order ?? 10_000) - (b.description?.order ?? 10_000),
    )
  const [promotionalAddons, baseAddons] = addonOptions.reduce(
    (acc: [PlansDescription[], PlansDescription[]], option) => {
      const [promotional, base] = acc
      if (option.description && option.description.isPromotional) {
        return [[...promotional, option], base]
      } else {
        return [promotional, [...base, option]]
      }
    },
    [[], []],
  )
  return {
    promotionalAddons,
    baseAddons,
  }
}
